import styled, { css } from 'styled-components'

import { breakpoint } from 'ui/elements/ThemeProvider/utils'
import { Box } from 'ui/elements/Icon/styles'
import OpticalHeading from 'ui/elements/Heading/OpticalHeading'
import { Col } from 'ui/elements/Grid'

export const Sidebar = styled.div<{
  color: string
}>`
  color: ${(props) => props.theme.palette[props.color]};

  > * {
    margin-bottom: 20px;
  }
`

export const IconContainer = styled.div`
  display: flex;
  align-items: flex-start;

  ${Box} {
    width: 100%;
  }

  max-width: 90px;
  svg {
    max-width: 30px;
  }

  ${breakpoint.md(
    () => css`
      max-width: none;

      svg {
        max-width: none;
      }
    `
  )}
`

export const Heading = styled(OpticalHeading)`
  ${breakpoint.md(
    () => css`
      display: none;
    `
  )}
`

/* Sidebar width in px */
export const fillContainer = css`
  ${breakpoint.md`
    margin-left: -192px;
  `}

  ${breakpoint.lg`
    margin-left: -248px;
  `}
    
  ${breakpoint.xl`
    margin-left: -195px;
  `}
`

export const fillPage = (hasSidebar: boolean) => css`
  ${breakpoint.md(
    () => css`
      margin-left: calc(
        0px - ${hasSidebar ? '(var(--sidebar-width) + 30px)' : '0px'} - 15px
      );
      margin-right: calc(-100vw / 2 + 768px / 2 - 15px);
      left: 0;
      right: 0;
    `
  )}

  ${breakpoint.lg`
    margin-left: calc(-100vw / 2 + 992px / 2 ${
      hasSidebar ? '- 248px' : ''
    } - 15px);
    margin-right: calc(-100vw / 2 + 992px / 2 - 15px);
  `}
    
  ${breakpoint.xl`
    margin-left: calc(-100vw / 2 + 1170px / 2 ${
      hasSidebar ? '- 195px' : ''
    } - 15px);
    margin-right: calc(-100vw / 2 + 1170px / 2 - 15px);
  `}
`

export const Main = styled(Col).attrs({
  as: 'main',
})<{
  $hasHeader: boolean
  $sidebarSize: {
    height: number
    width: number
  }
}>`
  margin-top: ${(props) => (props.$hasHeader ? '0' : '-20px')};
  margin-bottom: 30px;

  > *:first-child:only-child {
    min-height: ${(props) => props.$sidebarSize.height}px;
  }

  --sidebar-width: ${(props) => props.$sidebarSize.width}px;
  --sidebar-height: ${(props) => props.$sidebarSize.height}px;
`

export const MainHeading = styled(OpticalHeading)`
  display: none;

  ${breakpoint.md(
    () => css`
      display: block;
    `
  )}
`

export const MeetingLayout = styled.div`
  margin: 50px 0 0;
`

export const MeetingLayoutNoSidebar = styled(MeetingLayout)``
